import clsx from "clsx"

export type NpRadioButtonReadOnlyProps = {
  active: boolean
  disabled: boolean
}

export const NpRadioButtonReadOnly = ({ active, disabled }: NpRadioButtonReadOnlyProps) => {
  return (
    <div className="group flex size-10 items-center justify-center overflow-hidden rounded-full">
      <div
        className={clsx("flex size-8 items-center justify-center overflow-hidden rounded-full border bg-white", {
          "border-np-green": !disabled,
          "border-np-red": disabled,
        })}
      >
        <div
          className={clsx("size-5 rounded-full", {
            "bg-np-green": active && !disabled,
            "bg-np-red": active && disabled,
          })}
        />
      </div>
    </div>
  )
}
